<template>
  <v-card :min-height="cardMinHeight" :flat="darkMode" @click.stop="showDetails" :outlined="darkMode" class="item-bottom-border rounded-lg">
    <v-img :aspect-ratio="imageRatio" :src="teaserUrl" ref="image-preview" class="image-preview rounded-t-lg"></v-img>
    <div class="card-content" :style="`min-height:${cardContentMinHeight}`">
      <div class="px-4 py-1">
        <subtitle-1 v-if="item._labels" :newsItem="item" :dotRead="true"></subtitle-1>
        <subtitle-2
          v-else
          :item="item"
          :displayViewCounter="displayViewCounter"
          :displayPublicationTime="displayPublicationTime"
          :showFavorites="false"
          :dotRead="true"
        ></subtitle-2>
      </div>
      <div class="px-4 py-3 title-text">{{ item ? item.title : '' }}</div>
      <div class="text-content px-4 pb-3" @click.prevent.stop="showDetails">
        <div class="overflow-hidden op-text three-line" v-html="itemContent"></div>
      </div>
      <div class="normal-btn-wrapper">
        <v-btn class="mt-3" rounded outlined @click.stop.prevent="toggleQuickView">
          <v-icon>mdi-eye</v-icon>
          &nbsp;{{ $t('quickRead') }}
        </v-btn>
      </div>
    </div>
    <!-- quick view -->
    <v-dialog v-model="showQuickView" max-width="820">
      <v-card class="quickView">
        <v-img v-if="teaserUrl" :src="teaserUrl">
          <v-btn color="white closeBtn" fab dark small @click.stop.prevent="toggleQuickView">
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
        </v-img>
        <v-container :class="{ 'py-0': true, 'pt-2': true, 'pa-3': $vuetify.breakpoint.xs, 'pa-12': $vuetify.breakpoint.smAndUp }">
          <v-row dense no-gutters>
            <v-col>
              <subtitle-1 v-if="item._labels" :newsItem="item" :dotRead="false" :showAttachementCount="false"></subtitle-1>
              <subtitle-2
                class="mt-2"
                :item="item"
                :showAttachementCount="false"
                :displayViewCounter="displayViewCounter"
                :displayPublicationTime="displayPublicationTime"
              ></subtitle-2>
              <div v-if="item.title" class="py-4 px-0 text-h4 font-weight-medium">
                {{ item.title }}
              </div>
              <div v-if="itemContent" class="pa-0 pb-4">
                <div v-html="itemContent"></div>
              </div>
              <div v-if="sortedPdfs.length > 0" class="mx-0 pb-4">
                <v-btn v-for="pdf in sortedPdfs" :key="pdf.id" @click="showPdf(pdf)" class="pl-0 mr-1" text>
                  <v-icon>mdi-file-document-outline</v-icon>
                  {{ pdf.title }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- pdf view-->
    <v-dialog v-model="showPdfView" rounded="false" fullscreen hide-overlay>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="hidePdfView()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ pdfTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div v-if="pdfUrl !== null" style="height: calc(100vh - 64px) !important">
          <pdf-js
            :url="pdfUrl"
            :page="$route.query.page"
            :search="$route.query.search"
            :download-file-name="pdfTitle"
            :hide-pdf-open-icon="hidePdfOpenIcon"
          ></pdf-js>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import index from './index';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import config from '@/common/config';
import Subtitle1 from '../../components/Subtitle1.vue';
import Subtitle2 from '../../components/Subtitle2.vue';
import PdfJs from '@/components/pdf/PdfJs';
import readService from '@/services/readService';

export default {
  components: { Subtitle1, Subtitle2, PdfJs },
  mixins: [common, configMixin],
  props: {
    item: Object,
    moduleConfig: Object,
    fixImgHeight: { type: Boolean, default: false },
  },
  data() {
    return {
      showQuickView: false,
      pdf: null,
      showPdfView: false,
    };
  },
  computed: {
    sortedPdfs() {
      return this.item && this.item._pdfs ? this.item._pdfs.slice().sort((a, b) => a.sort - b.sort) : [];
    },
    displayViewCounter() {
      if (this.moduleConfig) {
        return this.moduleConfig.displayViewCounter !== undefined ? this.moduleConfig.displayViewCounter : true;
      }
      return true;
    },
    displayPublicationTime() {
      if (this.moduleConfig) {
        return this.moduleConfig.displayPublicationTime !== undefined ? this.moduleConfig.displayPublicationTime : true;
      }
      return true;
    },
    teaserExists() {
      return this.item && this.item._teasers && this.item._teasers.length > 0;
    },
    teaserUrl() {
      let teaser = this.item._teasers && this.item._teasers.length > 0 ? this.item._teasers[0] : null;
      return teaser ? `${config.apiUrl}/medias/news/${teaser.filename}/${teaser.checksum}` : '';
    },
    itemContent() {
      return this.item.content;
    },
    pdfUrl() {
      if (this.pdf) {
        return `${config.apiUrl}/medias/news/${this.pdf.filename}/${this.pdf.checksum}`;
      }
      return '';
    },
    pdfTitle() {
      return this.pdf ? this.pdf.title : '';
    },
    hidePdfOpenIcon() {
      let moduleConfig = this.getModuleConfig(index.moduleType, this.item.instance);
      if (moduleConfig) {
        return moduleConfig.hidePdfOpenIcon !== undefined ? moduleConfig.hidePdfOpenIcon : false;
      }
      return false;
    },
    isUnread() {
      return readService.isUnread(this.item);
    },
    imageRatio() {
      if (this.moduleConfig.imageRatio) {
        return this.moduleConfig.imageRatio;
      } else {
        return 2;
      }
    },
    cardMinHeight() {
      if (this.moduleConfig.cardMinHeight) {
        return `${this.moduleConfig.cardMinHeight}px`;
      } else {
        return '1px';
      }
    },
    cardContentMinHeight() {
      if (this.moduleConfig.cardContentMinHeight) {
        return `${this.moduleConfig.cardContentMinHeight}px`;
      } else {
        return '255px';
      }
    },
  },
  methods: {
    showDetails() {
      this.$router.push(`/news/${this.item.instance}/${this.item.id}`);
    },
    toggleQuickView() {
      this.showQuickView = !this.showQuickView;
      if (this.showQuickView && this.isUnread) {
        this.markAsRead();
      }
    },
    showPdf(pdf) {
      this.pdf = pdf;
      this.showPdfView = true;
    },
    hidePdfView() {
      this.showPdfView = false;
      this.pdf = null;
    },
    markAsRead() {
      if (this.item) {
        let type = this.$t(`type.${this.item._moduleId}`);
        let state = this.$t(`seen.${this.item._moduleId}`);
        let actionName = this.$t('action.marked');
        let sendboxTitle = this.item.title;
        let snackbarText = this.$t('markAsMsg', { type, title: this.item.title, state, actionName });

        this.$store.dispatch(
          `sendbox/markAsRead2`,
          {
            item: this.item,
            sendboxTitle,
            snackbarText,
            immediate: true,
          },
          { root: true }
        );
      }
    },
  },
};
</script>

<style scoped>
.closeBtn {
  width: 32px !important;
  height: 32px !important;
  opacity: 0.8;
  position: absolute;
  top: 12px;
  right: 12px;
}
.quickView {
  border: 3px solid white;
}
.text-content {
  position: relative;
}
.theme--light .gradient-overlay {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
}
.theme--dark .gradient-overlay {
  background: linear-gradient(to bottom, rgba(32, 32, 32, 0), rgba(32, 32, 32, 1));
}
.three-line {
  line-height: 1.4em;
  height: 4.3em;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* Buttons */
/* Normal button is one that is not very emphasized. If used within a normal-btn-wrapper div it can be used with a white / black padding as a floating action button*/
.normal-btn {
  margin: 8px;
}
.theme--light .normal-btn {
  background: #f0f0f0 !important;
  color: #505050 !important;
}
.theme--dark .normal-btn {
  background: #303030 !important;
  color: #d0d0d0 !important;
}
.theme--light .normal-btn-wrapper {
  background: rgba(255, 255, 255, 0.75);
}
.theme--dark .normal-btn-wrapper {
  background: rgba(32, 32, 32, 0.75);
}
.normal-btn-wrapper {
  border-radius: 28px;
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 3;
}
.title-text {
  font-weight: 700;
  font-size: 20px;
  line-height: 140%;
  letter-spacing: 0px;
}
</style>
